import { cn } from '@/shared/lib';
import { XIcon } from 'lucide-react';
import { FC, HTMLAttributes } from 'react';
import { useRTL } from '@/shared/hooks';
import { selectIsMinimalistic, useAppSelector } from '@/app/store';

export interface ModalProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  isDialog?: boolean;
  onClose: VoidFunction;
  contentClassName?: string;
}

export const ModalContent: FC<ModalProps> = ({
  onClose,
  children,
  isDialog = false,
  className,
  contentClassName,
  ...props
}) => {
  const isRTL = useRTL();
  const isMinimalistic = useAppSelector(selectIsMinimalistic);

  return (
    <div
      onMouseDown={() => {
        if (isDialog) onClose();
      }}
      className={cn(
        'flex justify-center items-center fixed top-0 left-0 bottom-0 z-[11] w-full h-[100dvh] overflow-hidden bg-black/25',
        className,
      )}
      {...props}
    >
      <section
        onMouseDown={(e) => e.stopPropagation()}
        className={cn(
          'p-6 rounded-lg relative w-full m-4 bg-background',
          isRTL && 'text-right',
          isMinimalistic && 'rounded-none',
          contentClassName,
        )}
        dir={isRTL ? 'rtl' : 'ltr'}
      >
        {!isDialog && (
          <XIcon
            size={24}
            className={cn(
              'absolute top-[calc(var(--height-header-mobile)+16px)] cursor-pointer text-white z-[13]',
              isRTL ? 'left-3' : 'right-3',
            )}
            onClick={onClose}
          />
        )}

        {children}
      </section>
    </div>
  );
};
